/**
 * Sanitize stored legacy additional fields data structures for a plan to support PM.
 * Since this data was created before plan settings default additional fields support,
 * existing saved fields are only for holder type.
 * @param {*} planInfo
 * @returns
 */
export const SanitizePlanLegacyAdditionalFields = planInfo => {
  const additionalFields = planInfo.fields ?? [];
  return {
    holder: [...additionalFields],
    position: []
  };
};
